<template>
  <div id="jmflow"  class="div-middle-all">
    <div class="title-sy"><span style="border-bottom: 1px solid rgb(124, 185, 186);">加盟流程</span></div>
    <div style="height: 450px" v-if="false">
      <el-steps direction="vertical" process-status="success" :active="10" style="color: rgb(124, 185, 186)">
        <el-step title="了解陌上" description="通过集团媒体信息">
          <template slot="icon">
            <i class="el-icon-user-solid step-color"></i>
          </template>
        </el-step>
        <el-step title="联系我们" description="这是一段很长很长很长的描述性文字">
          <template slot="icon">
            <i class="el-icon-phone step-color"></i>
          </template>
        </el-step>
        <el-step title="项目勘察" description="这是一段很长很长很长的描述性文字">
          <template slot="icon">
            <i class="el-icon-s-open step-color"></i>
          </template>
        </el-step>
        <el-step title="签署合同" description="这是一段很长很长很长的描述性文字">
          <template slot="icon">
            <i class="el-icon-s-order step-color"></i>
          </template>
        </el-step>
        <el-step title="筹建酒店" description="这是一段很长很长很长的描述性文字">
          <template slot="icon">
            <i class="el-icon-s-home step-color"></i>
          </template>
        </el-step>
        <el-step title="酒店开业" description="这是一段很长很长很长的描述性文字">
          <template slot="icon">
            <i class="el-icon-success step-color"></i>
          </template>
        </el-step>
      </el-steps>
    </div>
    <el-image :src="jmSrc" fit="scale-down"></el-image>
    <div class="title-sy"><span style="border-bottom: 1px solid rgb(124, 185, 186);">加盟服务</span><p>十大保障式加盟支持</p></div>
    <el-image :src="jmFwSrc" fit="scale-down"></el-image>
  </div>
</template>

<script>
export default {
  name: "JMflowPlugin",
  data() {
    return {
      jmSrc: require('../assets/images/02-051-jm-flow-1.png'),
      jmFwSrc: require('../assets/images/03-05-jm-fw-1.png')
    }
  }
}
</script>

<style scoped>
  #jmflow >>> .el-step__head.is-finish {
    border-color: rgb(124, 185, 186);
  }
  .step-color {
    color: rgb(124, 185, 186);
  }
  .title-sy{
    letter-spacing: 6px;
  }
  .title-sy >>> p{
    font-size: 14px;
    margin: 0 auto;
    letter-spacing: 0px;
  }
</style>
